import { makeStyles } from '@material-ui/core/styles';

export const STEP_WIDTH = 8.75;

export const useStyles = makeStyles(theme => ({
  stepper: {
    position: 'relative',
    justifyContent: 'space-between',
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
  },
  step: {
    position: 'unset',
    maxWidth: theme.spacing(STEP_WIDTH),
    minWidth: theme.spacing(STEP_WIDTH),
    padding: 0,
  },
  label: {
    '& .MuiStepLabel-label': {
      marginTop: theme.spacing(0.625),
      ...theme.typography.h5,
      color: theme.palette.gray.main,
    },

    '& .MuiStepLabel-active	': {
      ...theme.typography.h5,
      color: theme.palette.text.primary,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
}));
